"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.helpers = void 0;
const age_1 = require("./age");
const bool_1 = require("./bool");
const lodash_1 = require("lodash");
const currency_1 = require("./currency");
const formatDate_1 = require("./formatDate");
const formatPhone_1 = require("./formatPhone");
const height_1 = require("./height");
const defaultSuite_1 = require("./defaultSuite");
const ifEqual_1 = require("./ifEqual");
const ifExists_1 = require("./ifExists");
const householdIncome_1 = require("./householdIncome");
const casing_1 = require("./casing");
const medicalConditions_1 = require("./medicalConditions");
const multiply_1 = require("./multiply");
const startCase_1 = __importDefault(require("lodash/startCase"));
const sex_1 = require("./sex");
const slice_1 = require("./slice");
const transform_1 = require("./transform");
exports.helpers = {
    age: age_1.age,
    bool: bool_1.bool,
    capitalize: lodash_1.capitalize,
    currency: currency_1.currency,
    formatDate: formatDate_1.formatDate,
    formatPhone: formatPhone_1.formatPhone,
    height: height_1.height,
    heightInches: height_1.heightInches,
    heightFeet: height_1.heightFeet,
    default: defaultSuite_1.getDefault,
    getDefault: defaultSuite_1.getDefault,
    getDefaultString: defaultSuite_1.getDefaultString,
    getDefaultNumber: defaultSuite_1.getDefaultNumber,
    householdIncome: householdIncome_1.householdIncome,
    ifequal: ifEqual_1.ifequal,
    ifexists: ifExists_1.ifexists,
    lowerCase: casing_1.lowerCase,
    medicalConditions: medicalConditions_1.medicalConditions,
    multiply: multiply_1.multiply,
    title: startCase_1.default,
    upperCase: casing_1.upperCase,
    sex: sex_1.sex,
    slice: slice_1.slice,
    transform: transform_1.transform,
};
